export enum LoginError {
  ValidateEmail = '<b>Please validate your email!</b><br>Check your inbox and click the link to validate your email address.',
  InvalidCredentials = '<b>Invalid email or password!</b><br>Please try again.',
  UnknownError = 'unknownError',
}
